<template>
  <div class='problem'>

    <div class="title">
      <img src="@/assets/serve/problem/text.png" alt="">
    </div>

    <div class="proBox">
      
      <div class="proClass">
        <div class="classTit">问题分类</div>
        <div @click="selClass(index, item.id)" v-for="(item, index) in classList" :key="index" :class="classIndex === index? 'classItem selItem': 'classItem'">{{ item.class_name }}</div>
      </div>

      <div class="proList">
        <div v-for="(item, index) in list" :key="index" class="list-item">

          <div class="top" @click="showItem(index)">
            <div class="line"></div>
            <span>{{ item.question_name }}</span>
            <img :class="index === selIndex? 'toTop': ''" src="@/assets/serve/problem/jtImg.png" alt="">
          </div>
          <el-collapse-transition>
            <div v-show="index === selIndex" class="bot">{{ item.question_answer }}</div>
          </el-collapse-transition>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
const md5 = require('js-md5')
import qs from 'qs'
import Des from '@/util/des.js'
export default {
  name: 'problem',
  components: {
  },
  data() {
    return {
      classIndex: '',
      selIndex: '',
      classList: [],
      list: []
    }
  },
  computed: { },
  watch: {},
  created() {
    this.getClass()
  },
  mounted() {
  },
  methods: {
    getClass() {
      const stamp = Date.now()
      const data = {
        stamp,
        father_id: -1,
        sign: md5('-1' + stamp + atob(localStorage.getItem('okey')))
      }
      axios.post('/api/xiaosen/user/info/questionClassList', qs.stringify(data)).then(res => {
        if (res.data.result === 1) {
          const deskey = atob(localStorage.getItem('odeskey'))
          this.classIndex = 0
          this.classList = JSON.parse(Des.decryptByDES(res.data.dataList, deskey))
          console.log(this.classList)
          this.classList = [{ id: -1, class_name: '全部' }, ...this.classList]
          this.getQuestList(this.classList[0].id)
        } else {
          this.$message(res.data.msg)
        }
      })
    },
    getQuestList(id) {
      const stamp = Date.now()
      const data = {
        stamp,
        class_id: id,
        keyword: '',
        pageSize: 100,
        pageNum: 1,
        sign: md5(id + '' + stamp + '' + atob(localStorage.getItem('okey')))
      }
      axios.post('/api/xiaosen/user/info/questionList', qs.stringify(data)).then(res => {
        if (res.data.result === 1) {
          const deskey = atob(localStorage.getItem('odeskey'))
          this.list = JSON.parse(Des.decryptByDES(res.data.dataList, deskey))
          console.log(this.list)
        } else if (res.data.result === 0) {
          this.list = []
          this.$message(res.data.msg)
        }  else {
          this.$message(res.data.msg)
        }
      })
    },
    async selClass(index, id) {
      if (this.classIndex !== index) {
        await this.getQuestList(id)
        this.selIndex = ''
        this.classIndex = index
      }
    },
    showItem(index) {
      if (this.selIndex === index) {
        this.selIndex = ''
      } else {
        this.selIndex = index
      }
    }
  }
}
</script>
<style lang='less' scoped>
.problem {
  max-width: 1920px;
  margin: 0 auto;
  .title{
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 1920px;
    height: 485px;
    background: url('../../../assets/serve/problem/title.png') no-repeat;
    background-size: 100% 100%;
    img{
      width: 835px;
      height: 184px;
    }
  }

  .proBox{
    position: relative;
    justify-content: space-between;
    padding: 48px 241px 0 238.5px;
    margin-bottom: 40px;

    .proClass{
      float: left;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      width: 240px;
      background: #FFFFFF;
      box-shadow: 0px 0px 18px 0px rgba(216,216,216,0.75);
      border-radius: 15px;
      margin-bottom: 40px;
      .classTit{
        user-select: none;
        font-size: 36px;
        color: #595858;
        height: 140px;
        line-height: 153px;
      }
      .classItem{
        width: 160px;
        text-align: center;
        height: 50px;
        line-height: 50px;
        font-size: 24px;
        border-radius: 25px;
        color: #595858;
        margin-bottom: 45px;
        cursor: pointer;
      }
      .selItem{
        border-radius: 25px;
        color: #fff;
        background: #4E8B46;
      }
    }

    .proList{
      width: 1160px;
      margin-left: 280px;
      .list-item{
        width: 100%;
        margin-bottom: 36px;
        .top{
          cursor: pointer;
          display: flex;
          align-items: flex-start;
          width: 100%;
          min-height: 72px;
          background: #F5F8F4;
          border-radius: 15px;
          font-size: 30px;
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          color: #595858;
          padding: 17px 24px;
          box-sizing: border-box;
          .line{
            margin-top: 5px;
            width: 4px;
            height: 30px;
            background: #4E8B46;
          }
          span{
            flex: 1;
            padding: 0 150px 0 12px;
            text-align: left;
          }
          img{
            width: 38px;
            height: 38px;
            transition: all 0.3s linear;
          }
          .toTop{
            transform: rotate(-180deg);
          }
        }

        .bot{
          box-sizing: border-box;
          width: 100%;
          background: #FAFBF9;
          border-radius: 15px;
          font-size: 24px;
          line-height: 36px;
          padding: 25px;
          text-align: left;
          color: #595858;
        }
      }
    }
  }
}
</style>
